import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export function ArticleCard({ article, basePath }) {
  return (
    <article className="group flex h-full flex-col border border-brand-line bg-white p-7 transition-colors duration-200 hover:border-brand-gold/50" data-testid={`article-card-${article.slug}`}>
      <p className="eyebrow">{article.kategorie}</p>
      <h3 className="mt-3 font-serif text-2xl font-bold leading-tight">
        <Link to={`${basePath}/${article.slug}`} className="rounded-sm transition-colors duration-200 hover:text-brand-olive" data-testid={`article-link-${article.slug}`}>
          {article.title}
        </Link>
      </h3>
      <p className="mt-3 flex-1 text-sm leading-relaxed text-brand-brown-soft">{article.teaser}</p>
      <p className="mt-5">
        <span className="inline-flex items-center gap-2 text-sm font-bold text-brand-olive transition-colors duration-200 group-hover:text-brand-olive-dark">
          Weiterlesen <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" />
        </span>
      </p>
    </article>
  );
}

export function ArticleBody({ article }) {
  return (
    <div className="space-y-12">
      {article.sections.map((section) => (
        <section key={section.h2} aria-labelledby={`s-${section.h2.slice(0, 12).replace(/\W+/g, '-')}`}>
          <h2 id={`s-${section.h2.slice(0, 12).replace(/\W+/g, '-')}`} className="font-serif text-2xl font-bold leading-tight sm:text-3xl">
            {section.h2}
          </h2>
          {section.paragraphs?.map((p, i) => (
            <p key={i} className="mt-4 leading-relaxed text-brand-brown/90">{p}</p>
          ))}
          {section.list && (
            <ul className="mt-4 list-disc space-y-2 pl-6 leading-relaxed text-brand-brown/90 marker:text-brand-gold">
              {section.list.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          )}
        </section>
      ))}
    </div>
  );
}

export function ArticleMeta({ article, updatedLabel = 'Aktualisiert' }) {
  return (
    <p className="mt-4 text-sm text-brand-brown-soft">
      Von <span className="font-semibold">Felix Genuss Redaktion</span> · Veröffentlicht am{' '}
      <time dateTime={article.veroeffentlicht}>{new Date(article.veroeffentlicht).toLocaleDateString('de-CH', { day: 'numeric', month: 'long', year: 'numeric' })}</time>
      {' '}· {updatedLabel} am{' '}
      <time dateTime={article.geaendert}>{new Date(article.geaendert).toLocaleDateString('de-CH', { day: 'numeric', month: 'long', year: 'numeric' })}</time>
    </p>
  );
}

export function Disclaimer() {
  return (
    <aside className="mt-12 border-l-2 border-brand-gold bg-brand-beige p-6" data-testid="content-disclaimer">
      <p className="text-sm leading-relaxed text-brand-brown">
        <strong className="font-bold">Gut zu wissen:</strong> Die Inhalte von Felix Genuss dienen der allgemeinen Information und Inspiration. Sie ersetzen keine individuelle tierärztliche oder tierernährungsmedizinische Beratung. Bei gesundheitlichen Fragen wende dich bitte an deine Tierärztin oder deinen Tierarzt.
      </p>
    </aside>
  );
}
